module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n      | 仓库地址\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.stores,
      "rules": _vm.stores.form_rules,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "felx"
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_vm._v("\n          国内集货仓地址：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "地址：江苏太仓沙溪沙南西路1658号"
    },
    model: {
      value: (_vm.stores.address),
      callback: function($$v) {
        _vm.$set(_vm.stores, "address", $$v)
      },
      expression: "stores.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contacts"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "收货人：李庆中"
    },
    model: {
      value: (_vm.stores.contacts),
      callback: function($$v) {
        _vm.$set(_vm.stores, "contacts", $$v)
      },
      expression: "stores.contacts"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tel"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "电话：13901620438"
    },
    model: {
      value: (_vm.stores.tel),
      callback: function($$v) {
        _vm.$set(_vm.stores, "tel", $$v)
      },
      expression: "stores.tel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_vm._v("\n          国外集货仓地址：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "addressO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "地址：江苏太仓沙溪沙南西路1658号"
    },
    model: {
      value: (_vm.stores.addressO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "addressO", $$v)
      },
      expression: "stores.addressO"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactsO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "联系人：Justin Biber"
    },
    model: {
      value: (_vm.stores.contactsO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "contactsO", $$v)
      },
      expression: "stores.contactsO"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "telO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "电话：+14082029128"
    },
    model: {
      value: (_vm.stores.telO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "telO", $$v)
      },
      expression: "stores.telO"
    }
  })], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "fotet"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "margin-left": "-8vw"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onsub
    }
  }, [_vm._v("确认修改")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a9427f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/freightage/houserAddress.vue
// module id = 1220
// module chunks = 2